import { Component, OnInit, Input } from '@angular/core';
import { AdaCustomization } from 'core/models/ada-customization';

@Component({
  selector: 'lms-customizations-list-row',
  templateUrl: './customizations-list-row.component.html',
  styleUrls: ['./customizations-list-row.component.scss']
})
export class CustomizationsListRowComponent implements OnInit {
  @Input() customization: AdaCustomization;

  constructor() {}

  ngOnInit() {}
}
